<template>
    <div>
        <h4 class="mb-0" v-if="expiringBonus.length > 0">即將到期點數</h4>
        <div class="list-style" v-for="(item , index) in expiringBonus" :key="index" @click="showBonus">

            <div class="flex-grow-1">
                到期日期 {{item.pointsDeadlineDate}}
            </div>
            <div>
                <span class="big mr-1">{{item.expiringPoint}}</span>點 <i class="el-icon-arrow-right"/>
            </div>
        </div>

        <PullDownClose v-if="isShowPullDownBonus" @close="closePullDownBonus" class="big-pull">
            <BonusPointsPage isWeb class="content" @close="closePullDownBonus" :dataTokenWeb="dataTokenWeb"/>
        </PullDownClose>
    </div>
</template>

<script>
    import PullDownClose from "@/components/PullDownClose";
    import BonusPointsPage from "@/views/gift/BonusPointsPage";

    export default {
        name: "BonusPointExpiring",
        props: {
            expiringBonus: { type:Array, default: Array.of([]) },
        },
        components: {
            PullDownClose,
            BonusPointsPage,
        },
        data() {
            return {
                // expiringBonus:['',''],
                isShowPullDownBonus: false,
                dataTokenWeb: '',
            }
        },
        mounted() {

        },
        methods: {
            //關閉下滑彈窗
            closePullDownBonus(){
                this.isShowPullDownBonus = false
            },

            //開啟到期點數
            showBonus(item){
                //TODO 未完善，先導到紅利點數列表
                this.$store.commit("updateStoreWebAction", {
                    "action": "goRewardPoint",
                });
                // let dataToken = this.$crypto.objectToURIComponent({
                //     "usedType":  "BonusPointsPage",
                //     "id":        item.id,
                // })
                // this.dataTokenWeb = dataToken
                // this.isShowPullDownBonus = true
            },
        }
    }
</script>
<style lang="less" scoped>

</style>